module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-25.bbef14b5.png";